

export const ActionTypes = {
  PUSH_CHANGE: 'zola/cards/form_history/PUSH_CHANGE',
  POP_CHANGE: 'zola/cards/form_history/POP_CHANGE',
  CLEAR_HISTORY: 'zola/cards/form_history/CLEAR_HISTORY',
};


export const pushChange = changeFunc => ({
  type: ActionTypes.PUSH_CHANGE,
  payload: changeFunc
});

export const popChange = () => ({
  type: ActionTypes.POP_CHANGE,
});

export const clearHistory = () => ({
  type: ActionTypes.CLEAR_HISTORY
});



/** WEBPACK FOOTER **
 ** ./src/cards/actions/formHistoryActions.js
 **/